import { SourceType } from "@gx/ts-contracts/services/database/models/public_pb";

import { SOURCE_TYPE_TO_FEATURE_FLAG_MAP } from "@/pages/sources/constants";

import { useFeatureFlag } from "@/hooks/useFeatureFlag";

export const useSourceTypeEnabled = (sourceType: SourceType): boolean => {
  const featureFlag = SOURCE_TYPE_TO_FEATURE_FLAG_MAP[sourceType];
  const isEnabled = useFeatureFlag(featureFlag);
  return featureFlag ? isEnabled : false;
};
